import React from "react";

export default function HeaderAvatar({ initial, size = 32, className = "" }) {
  const letter = (initial || "U").charAt(0).toUpperCase();
  const fontSize = Math.round(size * 0.44);

  return (
    <span
      className={`app-header-avatar-circle ${className}`.trim()}
      style={{ width: size, height: size, fontSize }}
      aria-hidden="true"
    >
      {letter}
    </span>
  );
}
